import { usePetitionActionsPageData } from '#src/app/pages/actions/pageContext';

export function useCampaignActionsEnabled(): boolean {
	const {
		data: {
			featureConfigs: { campaignActionsConfig },
		},
	} = usePetitionActionsPageData();
	return Boolean(campaignActionsConfig?.enabled);
}
